export default __webpack_public_path__ + "static/media/tiktokshop.alt.f66925ce.png";